import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import CRMTable from "@metacrm/metacrm-material-ui/dist/Table";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import LoadingIcon from "components/LoadingComponent/LoadingIcon";
import IconTooltip from "@metacrm/metacrm-material-ui/dist/IconTooltip";

export default function BehaviorTable({
  data = [],
  headers = [],
  tableName = "",
  tooltip = "",
  loading = false,
}) {
  // const [order, setOrder] = useState("asc");
  // const [orderBy, setOrderBy] = useState("total");
  // const [sortedData, setSortedData] = useState([...data]);

  // useEffect(() => {
  //   const formatter = (value, decimal = 0) =>
  //     value.toLocaleString("en-US", {
  //       style: "currency",
  //       currency: "USD",
  //       minimumFractionDigits: decimal,
  //       maximumFractionDigits: decimal,
  //     });

  //   const sorted = [...data].sort((a, b) => {
  //     if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
  //     if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
  //     return 0;
  //   });

  //   const formattedData = sorted.map((item) => {
  //     return Object.fromEntries(
  //       Object.entries(item).map(([key, value]) => [key, formatter(value)])
  //     );
  //   });

  //   setSortedData(formattedData);
  // }, [order, orderBy, data]);

  // const handleRequestSort = (event, property) => {
  //   const isAsc = orderBy === property && order === "asc";
  //   setOrder(isAsc ? "desc" : "asc");
  //   setOrderBy(property);
  // };

  const renderContents = () =>
    data.map((row) =>
      headers.map(({ id }) => (
        <Box key={id} slot={id}>
          {row[id]}
        </Box>
      ))
    );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: "#FFF",
        borderRadius: "4px",
        p: "20px 16px 24px",
        position: "relative",
      }}
    >
      <Box fontSize="16px" fontWeight="500" mb="16px" color="#555555">
        {tableName} {tooltip && <IconTooltip content={tooltip} />}
      </Box>

      {loading ? (
        <LoadingIcon isAbsolute />
      ) : data.length > 0 ? (
        <CRMTable
          containerStyle={{ maxHeight: "400px" }}
          rowData={data}
          headers={headers}
          contents={renderContents()}
          isLoading={loading}
          noDataComponent={
            <EmptyIconStatus
              icon="table"
              wording="later"
              emptyTitle="No Data"
              emptyDescription="No data available for this table."
            />
          }
          // onRequestSort={handleRequestSort}
          // order={order}
          // orderBy={orderBy}
        />
      ) : (
        <Box height="210px">
          <EmptyIconStatus
            icon="table"
            wording="later"
            emptyTitle="No Data"
            emptyDescription="No data available for this table."
          />
        </Box>
      )}
    </Box>
  );
}
